export const NAVBAR_HEIGHT = 70
export const INPUT_HEIGHT = 37